// src/components/titlebar/hooks/useTitleBarActions.ts

import { useNavigate } from "react-router-dom"
import type { TitleBarActions } from "../types/titleBarTypes"
import { ELECTRON_ZOOM_CHANGED_EVENT } from "@shared/hooks/useElectronZoomCompensation"

export const useTitleBarActions = (): TitleBarActions => {
  const navigate = useNavigate()

  const emitZoomChanged = (zoomFactor?: number) => {
    if (typeof zoomFactor !== "number") {
      return
    }

    window.dispatchEvent(
      new CustomEvent(ELECTRON_ZOOM_CHANGED_EVENT, {
        detail: { zoomFactor },
      })
    )
  }

  const handleMinimize = () => {
    window.electronAPI?.minimize()
  }

  const handleMaximize = () => {
    window.electronAPI?.maximize()
  }

  const handleClose = () => {
    window.electronAPI?.close()
  }

  const handleZoomIn = () => {
    void window.electronAPI?.zoomIn?.().then(emitZoomChanged)
  }

  const handleZoomOut = () => {
    void window.electronAPI?.zoomOut?.().then(emitZoomChanged)
  }

  const handleResetZoom = () => {
    void window.electronAPI?.resetZoom?.().then(emitZoomChanged)
  }

  const handleGoHome = () => {
    navigate("/")
  }

  const executeMenuAction = async (action: string, params?: any) => {
    try {
      const result = await window.electronAPI?.executeMenuAction?.(action, params)
      if (result?.success) {
        console.log(`Menu action '${action}' executed successfully`)
      }
      return result
    } catch (error) {
      console.error(`Menu action '${action}' failed:`, error)
      return { success: false, error: String(error) }
    }
  }

  return {
    handleMinimize,
    handleMaximize,
    handleClose,
    handleZoomIn,
    handleZoomOut,
    handleResetZoom,
    handleGoHome,
    executeMenuAction,
  }
}
